import React, { useState } from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import ButtonRounded from "../../components/ButtonRounded";
import ModalContainer from "../../components/ModalContainer";
import {useModalSimpleStyles} from "../../common/styles/modalStyles";

const useStyles = useModalSimpleStyles;

interface ModalDeleteProps {
  open: boolean;
  onClose: () => void;
  handleDelete: () => void;
  item: {
    id: number;
    name: string;
  };
}

const ModalDelete: React.FC<ModalDeleteProps> = ({
  open,
  onClose,
  item,
  handleDelete,
}) => {
  const [isError, setIsError] = useState<boolean>(false);
  const classes = useStyles();

  return (
    <ModalContainer
      open={open}
      onClose={onClose}
      title="Are you sure you want to delete this file?"
    >
      <div className={classes.modalContent}>
        <Grid
          container
          alignItems="center"
          direction="column"
          spacing={2}
          className={classes.userContainer}
        >
          <Grid item>
            <Typography variant="body1">{item.name}</Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2} className={classes.btnContainer}>
          <Grid item xs={6}>
            <ButtonRounded
              fullWidth
              variant="outlined"
              onClick={onClose}
              color="default"
            >
              Cancel
            </ButtonRounded>
          </Grid>
          <Grid item xs={6}>
            <ButtonRounded
              fullWidth
              variant="contained"
              color="secondary"
              onClick={handleDelete}
              disabled={isError}
            >
              Delete
            </ButtonRounded>
          </Grid>
        </Grid>
        {isError && (
          <Typography align="center" variant="body2" color="error">
            Failed to delete this file.
          </Typography>
        )}
      </div>
    </ModalContainer>
  );
};

export default ModalDelete;
